/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import timeframeUnits from 'cio/utils/timeframe-units';
import integerToString from 'cio/utils/integer-to-string';
import WaitUntilAbstract, { EventDelayPath, TimeDirection } from 'cio/app-models/action-abstracts/wait-until';
import { tracked } from '@glimmer/tracking';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import CampaignModel from 'cio/models/campaign';

interface WaitUntilDelayEventAttributeEditorArgs {
  actionAbstract: WaitUntilAbstract;
  isSaving: boolean;
  hasReadOnlyPermission: boolean;
}

export default class WaitUntilDelayEventAttributeEditor extends Component<WaitUntilDelayEventAttributeEditorArgs> {
  get eventDelayPath() {
    return this.args.actionAbstract.eventDelayPath;
  }

  TimeDirection = TimeDirection;

  timeDirections = [
    {
      label: 'the time specified in',
      value: TimeDirection.On,
    },
    {
      label: 'before the time specified in',
      value: TimeDirection.Before,
    },
    {
      label: 'after the time specified in',
      value: TimeDirection.After,
    },
  ];

  @tracked offsetUnits = timeframeUnits({
    context: this.eventDelayPath as EventDelayPath,
    countProperty: 'delayEventAttrOffsetCount',
  });

  @integerToString('eventDelayPath.delayEventAttrOffsetCount') delayEventAttrOffsetCountValue!: string;

  get showRelativeTimeInputs() {
    return this.eventDelayPath?.delayEventAttrOffsetTimeDirection !== TimeDirection.On;
  }

  get conditionModel() {
    return EventAttributeCondition.create({
      event: (this.args.actionAbstract.action.belongsTo('campaign').value() as CampaignModel | null)?.event ?? '',
      name: this.eventDelayPath?.delayEventAttr ?? '',
    });
  }

  @action
  setDelayEventAttr(value: string) {
    if (this.eventDelayPath == null) {
      return;
    }

    this.eventDelayPath.delayEventAttr = value;
  }
}
